import { Translations } from './fr';

export const de: Translations = {
  nav: {
    home: "Startseite",
    primeEvolution: "Evolution",
    pulse: "Pulse",
    sparkle: "Sparkle",
    agents: "Agenten",
    partners: "Partner",
    contact: "Kontakt",
    recruitAgent: "Agent rekrutieren",
  },
  hero: {
    title: "Rekrutieren Sie unsere",
    titleHighlight: "KI-Agenten",
    titleEnd: "um Ihre Teams zu stärken",
    subtitle: "Virtuelle Mitarbeiter rund um die Uhr verfügbar, auf Ihre Geschäftsprozesse geschult, bereit Ihre Produktivität zu transformieren.",
    cta: "KI-Agent rekrutieren",
    discover: "Prime Evolution entdecken",
  },
  trust: {
    available: "24/7 Verfügbar",
    secure: "100% Sicher",
    agents: "Zertifizierte Agenten",
    support: "Dedizierter Support",
  },
  primeEvolution: {
    badge: "Unsere Flaggschiff-Lösung",
    title: "Prime Evolution",
    subtitle: "Das komplette Begleitprogramm zur Integration von KI in Ihr Unternehmen",
    description: "Prime Evolution ist unser ganzheitlicher Ansatz, der Audit, Schulung und Bereitstellung maßgeschneiderter KI-Agenten kombiniert.",
    features: {
      audit: { title: "Strategisches Audit", description: "Tiefgehende Analyse Ihrer Prozesse zur Identifikation von Automatisierungsmöglichkeiten." },
      training: { title: "Team-Schulung", description: "Angepasste Schulungsprogramme für effektive Zusammenarbeit mit KI." },
      deployment: { title: "Maßgeschneiderte Bereitstellung", description: "Personalisierte KI-Agenten, integriert in Ihre bestehenden Tools." },
      support: { title: "Kontinuierliche Unterstützung", description: "Dedizierter Support und kontinuierliche Optimierung." },
    },
    cta: "Prime Evolution starten",
    stats: { productivity: "Durchschnittlicher Produktivitätsgewinn", roi: "Kapitalrendite", satisfaction: "Kundenzufriedenheitsrate" },
  },
  pulse: {
    badge: "Intelligente Automatisierung",
    title: "VEECTORIA Pulse",
    subtitle: "Automatisierung im Rhythmus Ihres Unternehmens",
    description: "Pulse ist unsere intelligente Automatisierungsplattform für Echtzeit-Workflow-Orchestrierung.",
    features: {
      connect: { title: "Verbinden", description: "Native Integration mit über 200 professionellen Tools." },
      orchestrate: { title: "Orchestrieren", description: "Intelligente Workflows, die sich automatisch anpassen." },
      optimize: { title: "Optimieren", description: "Echtzeit-Analyse und Empfehlungen zur Prozessverbesserung." },
    },
    cta: "Pulse entdecken",
  },
  advantages: {
    badge: "Warum uns wählen",
    title: "VEECTORIA Vorteile",
    subtitle: "Ein einzigartiger Ansatz, der menschliche Expertise mit KI-Kraft verbindet",
    items: {
      expertise: { title: "Anerkannte Expertise", description: "Über 10 Jahre Erfahrung in digitaler Transformation und KI." },
      custom: { title: "Maßgeschneiderte Lösungen", description: "Jeder Agent wird speziell auf Ihre Prozesse trainiert." },
      security: { title: "Maximale Sicherheit", description: "Daten in Europa gehostet, DSGVO-Konformität garantiert." },
      roi: { title: "Garantierte ROI", description: "Ergebnisverpflichtung mit messbaren Indikatoren." },
      support: { title: "24/7 Support", description: "Dediziertes Team jederzeit verfügbar." },
      evolution: { title: "Kontinuierliche Entwicklung", description: "Ihre Agenten verbessern sich ständig durch Machine Learning." },
    },
  },
  sparkle: {
    badge: "Intelligente Digitalisierung",
    title: "Sparkle",
    subtitle: "TagPDF v7 mit KI",
    description: "Verwandeln Sie Ihre Papierdokumente in nutzbare Daten mit unserer intelligenten Digitalisierungslösung. Automatische Erkennung, Datenextraktion und intelligente Klassifizierung.",
    features: {
      scan: {
        title: "Erweiterte Digitalisierung",
        description: "Hochpräzises OCR für alle Dokumenttypen.",
      },
      ai: {
        title: "Integrierte KI",
        description: "Automatische Klassifizierung und Extraktion wichtiger Daten.",
      },
      speed: {
        title: "Ultraschnelle Verarbeitung",
        description: "Tausende Seiten in Minuten verarbeitet.",
      },
      accuracy: {
        title: "Maximale Genauigkeit",
        description: "Erkennungsrate über 99%.",
      },
    },
    cta: "Sparkle entdecken",
    ctaFulltext: "Volltext-Indexierung",
    ctaFulltextDesc: "Suchen Sie sofort in allen Ihren Dokumenten.",
    ctaScan: "Blitz-Scan → Ordner",
    ctaScanDesc: "Scannen und organisieren im Handumdrehen.",
  },
  testimonials: {
    badge: "Testimonials",
    title: "Sie vertrauen uns",
    subtitle: "Entdecken Sie, wie unsere Kunden ihr Geschäft mit VEECTORIA transformieren",
    items: [
      { quote: "Dank VEECTORIA haben wir Verwaltungsaufgaben um 70% reduziert.", metric: "-70%", metricLabel: "Verwaltungszeit", name: "Isabelle G.", role: "Verwaltungsleiterin" },
      { quote: "Der KI-Agent hat unsere Akquise transformiert. +40% qualifizierte Termine.", metric: "+40%", metricLabel: "qualifizierte Termine", name: "Marc D.", role: "Vertriebsleiter" },
      { quote: "Die Dokumentenlösung spart wertvolle Zeit bei der Aktenverwaltung.", metric: "5x", metricLabel: "schneller", name: "Sophie M.", role: "Geschäftsführerin" },
    ],
  },
  faq: {
    badge: "Häufig gestellte Fragen",
    title: "Alles über VEECTORIA",
    subtitle: "Antworten auf Ihre häufigsten Fragen",
    items: {
      q1: { question: "Was ist ein VEECTORIA KI-Agent?", answer: "Ein intelligenter virtueller Mitarbeiter, der auf Ihre spezifischen Geschäftsprozesse trainiert ist." },
      q2: { question: "Wie lange dauert die Bereitstellung?", answer: "Die Standardbereitstellung dauert 2-4 Wochen, für komplexere Anforderungen 6-8 Wochen." },
      q3: { question: "Sind meine Daten sicher?", answer: "Absolut. Alle Daten werden in Europa auf zertifizierten Servern gehostet, 100% DSGVO-konform." },
      q4: { question: "Welche Rendite ist zu erwarten?", answer: "Unsere Kunden erzielen durchschnittlich 40% Produktivitätssteigerung und positive ROI in 3 Monaten." },
      q5: { question: "Wie funktioniert die Integration?", answer: "VEECTORIA integriert sich nativ mit über 200 professionellen Tools." },
    },
  },
  contact: {
    badge: "Kontaktieren Sie uns",
    title: "Bereit, Ihr Unternehmen zu transformieren?",
    subtitle: "Lassen Sie uns Ihre Bedürfnisse besprechen",
    form: {
      name: "Vollständiger Name",
      email: "Geschäftliche E-Mail",
      company: "Unternehmen",
      phone: "Telefon",
      message: "Ihre Nachricht",
      submit: "Nachricht senden",
      sending: "Wird gesendet...",
      success: "Nachricht erfolgreich gesendet!",
      error: "Fehler beim Senden. Bitte erneut versuchen.",
    },
    info: { title: "Kontaktinformationen", email: "E-Mail", phone: "Telefon", address: "Adresse" },
  },
  cta: {
    title: "Bereit zu handeln?",
    subtitle: "Schließen Sie sich den Unternehmen an, die ihre Produktivität bereits mit VEECTORIA transformiert haben",
    button: "KI-Agent rekrutieren",
  },
  footer: {
    description: "Künstliche Intelligenz-Lösungen zur Transformation Ihres Unternehmens.",
    navigation: "Navigation",
    legal: "Impressum",
    privacy: "Datenschutz",
    terms: "AGB",
    cookies: "Cookie-Einstellungen",
    rights: "Alle Rechte vorbehalten.",
  },
  agents: {
    badge: "Unser Team",
    title: "Unsere KI-Agenten",
    subtitle: "Entdecken Sie unsere virtuellen Mitarbeiter",
  },

  // AI Agents Showcase
  agentsShowcase: {
    badge: "KI-Exzellenz für Ihr Unternehmen",
    title: "Unsere KI-Agenten Transformieren Ihren Alltag",
    description: "Stellen Sie sich ein Team virtueller Mitarbeiter vor, das niemals schläft, ständig lernt und sich perfekt an Ihre Geschäftsprozesse anpasst. Unsere KI-Agenten erweitern Ihre Fähigkeiten, befreien Ihre Talente von wiederkehrenden Aufgaben und steigern Ihre Produktivität auf ein neues Niveau.",
    imageAlt: "VEECTORIA KI-Agenten Team",
    cta: "Unsere Agenten entdecken",
    benefits: {
      availability: "24/7 Verfügbar",
      productivity: "10x Produktivität",
      performance: "Optimale Leistung",
      collaboration: "Nahtlose Zusammenarbeit",
    },
  },
  cookies: {
    title: "Cookie-Verwaltung",
    message: "Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern, den Datenverkehr zu analysieren und Inhalte zu personalisieren.",
    accept: "Alle akzeptieren",
    decline: "Ablehnen",
    settings: "Anpassen",
    settingsTitle: "Cookie-Einstellungen",
    settingsDescription: "Verwalten Sie Ihre Cookie-Präferenzen. Essentielle Cookies sind für die Funktion der Website notwendig und können nicht deaktiviert werden.",
    saveChoices: "Meine Auswahl speichern",
    rejectAll: "Alle ablehnen",
    alwaysActive: "Immer aktiv",
    categories: {
      essential: { name: "Essentielle Cookies", description: "Diese Cookies sind für die Funktion der Website notwendig und können nicht deaktiviert werden." },
      analytics: { name: "Analyse-Cookies", description: "Diese Cookies ermöglichen es uns, die Zielgruppe der Website zu messen und das Browsing-Verhalten zu analysieren." },
      marketing: { name: "Marketing-Cookies", description: "Diese Cookies werden verwendet, um personalisierte Werbung anzubieten." },
      preferences: { name: "Präferenz-Cookies", description: "Diese Cookies speichern Ihre Präferenzen (Sprache, Thema, Region)." },
    },
  },

  // Partners Section
  partners: {
    badge: "Partnerprogramm",
    title: "Gemeinsam Entwickeln",
    description: "Sind Sie Wiederverkäufer, Distributor, Software-Editor oder Großhändler? VEECTORIA wird Ihr bevorzugter Technologiepartner, um neue Märkte mit modernsten KI-Lösungen zu erobern.",
    valueProposition: "Wir entwickeln komplette, maßgeschneiderte professionelle Lösungen für Ihre Kunden und unterstützen Sie bei der Umsetzung einer Massenvermarktungsstrategie. Attraktive Margen, dedizierter technischer Support und Marketing-Unterstützung: alle Zutaten für Ihren Erfolg.",
    types: {
      resellers: { title: "Wiederverkäufer", description: "Integrieren Sie unsere KI-Lösungen in Ihren Katalog und bieten Sie differenzierende Angebote." },
      distributors: { title: "Distributoren", description: "Implementieren Sie unsere Technologien großflächig in Ihrem Gebiet." },
      editors: { title: "Software-Editoren", description: "Erweitern Sie Ihre Software mit unserer KI für unvergleichlichen Mehrwert." },
      wholesalers: { title: "Großhändler", description: "Erhalten Sie Vorzugspreise für Massenvertrieb in Ihren Netzwerken." },
    },
    benefits: {
      title: "Ihre Partnervorteile",
      whiteLabel: "White-Label-Lösungen",
      support: "Dedizierter technischer Support",
      scalability: "Unbegrenzte Skalierbarkeit",
    },
    cta: "Partner werden",
    ctaSubtext: "Kontaktieren Sie uns, um unser exklusives Partnerprogramm zu entdecken",
  },

  legal: {
    lastUpdate: "Letzte Aktualisierung: Januar 2026",
    mentions: {
      title: "Impressum",
      sections: {
        editor: { title: "1. Herausgeber der Website", intro: "Diese Website wird herausgegeben von:", companyName: "Firmenname", legalForm: "Rechtsform", capital: "Stammkapital", address: "Firmensitz", siren: "SIREN", siret: "SIRET", rcs: "RCS", tva: "USt-IdNr.", naf: "NAF-Code" },
        publication: { title: "2. Verantwortlich für den Inhalt", intro: "Für den Inhalt verantwortlich:", since: "seit" },
        contact: { title: "3. Kontakt", phone: "Telefon", email: "E-Mail" },
        hosting: { title: "4. Hosting", intro: "Die Website wird gehostet von:", name: "Name", address: "Adresse" },
        intellectual: { title: "5. Geistiges Eigentum", content1: "Diese gesamte Website unterliegt dem französischen und internationalen Urheberrecht und geistigem Eigentumsrecht. Alle Vervielfältigungsrechte sind vorbehalten.", content2: "Die Vervielfältigung dieser Website ganz oder teilweise ist ohne ausdrückliche Genehmigung von streng verboten" },
        liability: { title: "6. Haftungsbeschränkung", content: "Die Informationen auf dieser Website sind so genau wie möglich. {company} kann nicht für direkte oder indirekte Schäden aus der Nutzung dieser Website haftbar gemacht werden." },
        law: { title: "7. Anwendbares Recht", content: "Diese Website unterliegt französischem Recht. Bei Streitigkeiten sind ausschließlich französische Gerichte zuständig." },
      },
    },
    privacy: {
      title: "Datenschutzrichtlinie",
      sections: {
        intro: { title: "1. Einleitung", content: "{company} verpflichtet sich, die Privatsphäre der Nutzer seiner Website zu schützen. Diese Datenschutzrichtlinie erklärt, wie wir Ihre personenbezogenen Daten gemäß der DSGVO erfassen, verwenden und schützen." },
        controller: { title: "2. Verantwortlicher", company: "Unternehmen", address: "Adresse", email: "E-Mail" },
        data: { title: "3. Erfasste Daten", intro: "Wir erfassen folgende Daten:", items: ["Identifikationsdaten: Name, Vorname, E-Mail, Telefon", "Berufliche Daten: Unternehmen, Position", "Navigationsdaten: IP-Adresse, Cookies, besuchte Seiten", "Kommunikationsdaten: Nachrichten über Kontaktformulare"] },
        purposes: { title: "4. Verarbeitungszwecke", intro: "Ihre Daten werden erfasst für:", items: ["Beantwortung Ihrer Kontaktanfragen", "Bereitstellung unserer KI-Dienste", "Verbesserung unserer Website", "Versand kommerzieller Mitteilungen (mit Ihrer Zustimmung)", "Erfüllung gesetzlicher Verpflichtungen"] },
        basis: { title: "5. Rechtsgrundlage", intro: "Die Verarbeitung basiert auf:", items: ["Ihrer ausdrücklichen Einwilligung", "Vertragserfüllung", "Unserem berechtigten Interesse", "Gesetzlichen Verpflichtungen"] },
        retention: { title: "6. Aufbewahrungsdauer", content: "Ihre Daten werden für die erforderliche Dauer aufbewahrt, maximal 3 Jahre nach Ihrem letzten Kontakt." },
        rights: { title: "7. Ihre Rechte", intro: "Gemäß DSGVO haben Sie folgende Rechte:", access: "Auskunftsrecht", accessDesc: "Kopie Ihrer Daten erhalten", rectification: "Berichtigungsrecht", rectificationDesc: "unrichtige Daten korrigieren", erasure: "Löschungsrecht", erasureDesc: "Löschung Ihrer Daten verlangen", restriction: "Einschränkungsrecht", restrictionDesc: "Verarbeitung einschränken", portability: "Datenübertragbarkeit", portabilityDesc: "Daten in strukturiertem Format erhalten", objection: "Widerspruchsrecht", objectionDesc: "der Verarbeitung widersprechen", contact: "Zur Ausübung dieser Rechte kontaktieren Sie uns unter:" },
        security: { title: "8. Sicherheit", content: "Wir setzen geeignete technische und organisatorische Maßnahmen zum Schutz Ihrer Daten ein." },
        complaint: { title: "9. Beschwerde", content: "Sie können eine Beschwerde bei der CNIL einreichen: www.cnil.fr" },
      },
    },
    cgv: {
      title: "Allgemeine Geschäftsbedingungen",
      sections: {
        object: { title: "1. Gegenstand", content: "Diese AGB regeln die Vertragsbeziehungen zwischen {company} und seinen Kunden für KI-Dienste, Softwareentwicklung und Geschäftslösungen." },
        provider: { title: "2. Anbieter", company: "Unternehmen", siret: "SIRET", address: "Adresse" },
        services: { title: "3. Angebotene Dienste", intro: "{company} bietet folgende Dienste an:", items: ["Spezialisierte KI-Agenten", "Individuelle Geschäftsanwendungen (Prime Evolution)", "Dokumenten-KI-Lösungen", "VEECTORIA Pulse - Transkriptionsplattform", "KI-Beratung und Integration"] },
        quotes: { title: "4. Angebote und Bestellungen", content: "Alle Leistungen erfolgen auf Basis eines detaillierten Angebots." },
        pricing: { title: "5. Preise und Zahlung", content1: "Preise in Euro netto. MwSt. 20%. Zahlbar innerhalb 30 Tagen.", content2: "Bei Zahlungsverzug fallen Verzugszinsen an." },
        delivery: { title: "6. Lieferung und Fristen", content: "Lieferzeiten sind unverbindlich. {company} bemüht sich um Einhaltung der vereinbarten Fristen." },
        intellectual: { title: "7. Geistiges Eigentum", content: "Entwicklungen bleiben Eigentum von {company} bis zur vollständigen Zahlung." },
        confidentiality: { title: "8. Vertraulichkeit", content: "Beide Parteien verpflichten sich zur Vertraulichkeit für 3 Jahre nach Vertragsende." },
        liability: { title: "9. Haftungsbeschränkung", content: "Die Haftung von {company} ist auf den Vertragswert begrenzt." },
        law: { title: "10. Anwendbares Recht", content: "Es gilt französisches Recht. Gerichtsstand ist Paris." },
      },
    },
    cookiesPolicy: {
      title: "Cookie-Richtlinie",
      sections: {
        what: { title: "1. Was ist ein Cookie?", content: "Ein Cookie ist eine kleine Textdatei, die beim Besuch einer Website auf Ihrem Gerät gespeichert wird." },
        types: { title: "2. Verwendete Cookies", intro: "Unsere Website verwendet folgende Cookies:", essential: "Essentielle Cookies", essentialDesc: "Für die Funktion der Website notwendig.", analytics: "Analyse-Cookies", analyticsDesc: "Helfen uns, die Nutzung zu verstehen.", preferences: "Präferenz-Cookies", preferencesDesc: "Speichern Ihre Einstellungen." },
        retention: { title: "3. Aufbewahrungsdauer", content: "Cookies werden maximal 13 Monate gespeichert." },
        management: { title: "4. Cookie-Verwaltung", intro: "Sie können Ihre Cookie-Einstellungen jederzeit ändern:", items: ["Chrome: Einstellungen → Datenschutz → Cookies", "Firefox: Optionen → Datenschutz → Cookies", "Safari: Einstellungen → Datenschutz → Cookies", "Edge: Einstellungen → Cookies"] },
        contact: { title: "5. Kontakt", content: "Bei Fragen zu Cookies kontaktieren Sie uns unter:" },
      },
    },
  },
};
